<template>
  <div>
    <head>
      <title>Taxi1</title>
    </head>

    <!-- Loading Spinner -->
    <div class="loader-wrapper" v-if="loading">
      <div class="custom-loader">
        <img src="@/assets/images/icon/load.png" alt="loading" class="rotating-image" />
      </div>
    </div>

    <router-view v-else></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      loading: true,
    };
  },
  watch: {
    '$route'() {
      this.toggleLoader();
    },
  },
  methods: {
    toggleLoader() {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 1000); // 1秒後關閉loading
    },
  },
  mounted() {
    this.loading = false;
  },
};
</script>

<style scoped>
/* 背景及loader wrapper */
.loader-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #051c2c !important; /* 背景色設置 */
  z-index: 9999;
  overflow: hidden;
}

/* 自定義loader樣式 */
.custom-loader {
  display: flex;
  justify-content: center;
  align-items: center;
}

/* 圖片旋轉動畫 */
.rotating-image {
  width: 80px;
  height: 80px;
  animation: rotate 2s linear infinite; /* 2秒的旋轉動畫 */
}

/* 旋轉動畫效果 */
@keyframes rotate {
  100% {
    transform: rotate(1500deg);
  }
}
</style>
